/* global attachEvent */

// *******************************************************************************
// Open Order Modal
// *******************************************************************************

attachEvent('.pdf-card-list__archive-list .pdf-card', 'click', (ev) => {
  const parentEle = ev.target.closest('.pdf-card-list');
  const modalEle = parentEle.querySelector('.modal-order');
  modalEle.classList.add('is-open-modal');
});
